import { jsx, Fragment } from 'react/jsx-runtime';
import { useBrowser } from '@circlefin/hooks';
import classNames from 'classnames';
import { Chiclets } from '../Chiclets/Chiclets.es.js';
import variants from './variants/index.es.js';

const Coolwhip = ({ variant, opacity = 0.3, className, ...rest })=>{
    const { browser } = useBrowser();
    const classes = classNames('cb-coolwhip', variant, className);
    const background = variants[variant];
    /**
     * Construct the Chiclets
     * Passing opacity from the Coolwhip props to control Chiclets opacity
     * So they can overflow on each other and mix the colors.
     */ function ChicletsGroup() {
        return jsx(Fragment, {
            children: background.map(({ variant, ...props }, k)=>jsx(Chiclets, {
                    ...props,
                    opacity: opacity,
                    variant: variant
                }, `chiclets-${variant}${k}`))
        });
    }
    /**
     * Safari does not support `filter: blur()` on nested SVGs
     * This is a workaround to apply the filter to the child svg.
     */ const totalBlur = background.reduce((prev, acc)=>prev + (acc.blur ?? 0), 0);
    const averageBlur = totalBlur / background.length;
    const safariBlur = Math.min(parseInt(averageBlur.toFixed(2), 10) * 4, 68);
    /**
     * This component can be rendered well only on client side, in applications
     * with server side rendering we will wait for the browser to be available to have smooth render.
     */ return !browser ? null : jsx("svg", {
        "aria-hidden": "true",
        className: classes,
        focusable: "false",
        style: browser?.isSafari ? {
            filter: `blur(${safariBlur}px)`
        } : {},
        viewBox: "0 0 1440 1024",
        xmlns: "http://www.w3.org/2000/svg",
        ...rest,
        children: jsx(ChicletsGroup, {})
    });
};
Coolwhip.displayName = 'Coolwhip';

export { Coolwhip as default };
//# sourceMappingURL=Coolwhip.es.js.map
